import React, { FunctionComponent } from 'react';
import LogoDisplay, { LogoItem } from './LogoDisplay';
import KsimSection from './KsimSection';
import { SalesAndResourcesSimulationToolsOverviewContent } from '../../../graphql/pimcore/modules/siteContent/types/SalesAndResourcesSimulationToolsContent';

interface ToolPageProps {
    cmsContent: SalesAndResourcesSimulationToolsOverviewContent;
}

const ToolPage: FunctionComponent<ToolPageProps> = ({ cmsContent }) => {
    const logos: LogoItem[] = [
        {
            imageUrl: cmsContent.Tools.CapacitorAnalysis.toolImage.imageUrl,
            title: cmsContent.Tools.CapacitorAnalysis.toolTitle.linkText,
            titleHeight: 40,
            redirectUrl: cmsContent.Tools.CapacitorAnalysis.toolTitle.linkUrl,
            description: cmsContent.Tools.CapacitorAnalysis.toolSubtitle.content,
        },
        {
            imageUrl: cmsContent.Tools.FilmLifetime.toolImage.imageUrl,
            title: cmsContent.Tools.FilmLifetime.toolTitle.linkText,
            titleHeight: 40,
            redirectUrl: cmsContent.Tools.FilmLifetime.toolTitle.linkUrl,
            description: cmsContent.Tools.FilmLifetime.toolSubtitle.content,
        },
        {
            imageUrl: cmsContent.Tools.CeramicAging.toolImage.imageUrl,
            title: cmsContent.Tools.CeramicAging.toolTitle.linkText,
            titleHeight: 40,
            redirectUrl: cmsContent.Tools.CeramicAging.toolTitle.linkUrl,
            description: cmsContent.Tools.CeramicAging.toolSubtitle.content,
        },
        {
            imageUrl: cmsContent.Tools.InductorAnalysis.toolImage.imageUrl,
            title: cmsContent.Tools.InductorAnalysis.toolTitle.linkText,
            titleHeight: 40,
            redirectUrl: cmsContent.Tools.InductorAnalysis.toolTitle.linkUrl,
            description: cmsContent.Tools.InductorAnalysis.toolSubtitle.content,
        },
        {
            imageUrl: cmsContent.Tools.CapacitorLifetime.toolImage.imageUrl,
            title: cmsContent.Tools.CapacitorLifetime.toolTitle.linkText,
            titleHeight: 80,
            redirectUrl: cmsContent.Tools.CapacitorLifetime.toolTitle.linkUrl,
            description: cmsContent.Tools.CapacitorLifetime.toolSubtitle.content,
        },
        {
            imageUrl: cmsContent.Tools.FITAnalysis.toolImage.imageUrl,
            title: cmsContent.Tools.FITAnalysis.toolTitle.linkText,
            titleHeight: 40,
            redirectUrl: cmsContent.Tools.FITAnalysis.toolTitle.linkUrl,
            description: cmsContent.Tools.FITAnalysis.toolSubtitle.content,
            isNavigate: true,
        },
    ];

    return (
        <>
            <LogoDisplay logos={logos} />
            <KsimSection cmsContent={cmsContent.PreBuiltProjects} />
        </>
    );
};

export default ToolPage;
